import gql from 'graphql-tag';

export const getLeases = gql`
  query getLeases {
    getLeases {
      id
      savingsGSTThisMonth
      savingsToDateGST
      savingsToDateTax
      vehicleImg
      vehicleRego
      term
      currentMonth
      currentBalance
      leaseStartDate
      leaseActive
      isEv
    }
  }
`;

export const getLease = gql`
  query getLease($leaseId: String!) {
    getLease(leaseId: $leaseId) {
      id
      savingsGSTThisMonth
      savingsToDateGST
      savingsToDateTax
      vehicleRego
      vehicleImg
      term
      currentMonth
      currentBalance
      leaseType
      leaseActive
      carLeaseCost
      runningBudgetCost
      otherCosts
      totalLeaseCost
      impactOnTakeHomePay
      leaseStartDate
      leaseEndDate
      leaseAnnualKM
      interestRate
      financier
      residualValue
      primaryDocuments {
        label
        url
      }
      registrationPaidUntil
      vehicleDescription
      vehicleVin
      insurer
      insuranceRenewalDate
      allianzDocuments {
        label
        url
      }
      otherDocuments {
        label
        url
      }
    }
  }
`;
